import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { lawtonConfig } from "./data";

export default function LawtonPage() {
  return <CityPageTemplate config={lawtonConfig} />;
}